import * as React from 'react';
import { matchPath, useLocation } from 'react-router';
import { TProductPage, TProductPageKind } from './ProductPage.types';
import './ProductPage.styled.scss';
import { APP_ROUTES } from 'constants/routes';
import { PhoneCaseProduct } from './components/PhoneCaseProduct/PhoneCaseProduct';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

export const ProductPage: TProductPage = () => {
  const localize = useLocalize();
  const { pathname } = useLocation();

  const productPageKind = React.useMemo((): TProductPageKind | null => {
    if (
      matchPath({ path: APP_ROUTES.PHONE_CASE_PRODUCT, end: true }, pathname)
    ) {
      return 'phoneCase';
    }
    return null;
  }, [pathname]);

  if (productPageKind === null) {
    return (
      <div className="product-page">
        <div className="product-page__container">
          <h2 className="product-page__error">
            {localize('product.page.not.found')}
          </h2>
        </div>
      </div>
    );
  }

  return (
    <div className="product-page">
      <div className="product-page__container">
        {productPageKind === 'phoneCase' && <PhoneCaseProduct />}
      </div>
    </div>
  );
};
